import api from '../../api';

/**
 * Typed-ish wrappers over the OPE-112 discount JSON API (plain JSON, no
 * {value} envelope) so screens do not repeat URLs.
 *
 * V2.7: coupons are a top-level catalogue of reusable terms; a promotion
 * points at one coupon and is what gets applied to a client.
 */
export default {
    referenceData: () => api.getJson('discount_reference_data'),

    listPromotions: (filters = {}) => api.getJson('discount_promotions', filters),
    getPromotion: id => api.getJson(`discount_promotions/${id}`),
    createPromotion: body => api.postJson('discount_promotions', body),
    updatePromotion: (id, body) => api.patchJson(`discount_promotions/${id}`, body),
    promotionAction: (id, action) => api.postJson(`discount_promotions/${id}/${action}`),
    promotionAudit: id => api.getJson(`discount_promotions/${id}/audit_events`),
    setPromotionCode: (id, code) => api.putJson(`discount_promotions/${id}/code`, { code }),
    bulkApplyPromotion: (id, body) => api.postJson(`discount_promotions/${id}/bulk_apply`, body),

    listCoupons: (filters = {}) => api.getJson('discount_coupons', filters),
    getCoupon: id => api.getJson(`discount_coupons/${id}`),
    createCoupon: body => api.postJson('discount_coupons', body),
    updateCoupon: (id, body) => api.patchJson(`discount_coupons/${id}`, body),
    couponAction: (id, action) => api.postJson(`discount_coupons/${id}/${action}`),
    bulkApplyCoupon: (id, body) => api.postJson(`discount_coupons/${id}/bulk_apply`, body),

    listClientDiscounts: clientId => api.getJson(`clients/${clientId}/discounts`),
    getClientDiscount: (clientId, id) => api.getJson(`clients/${clientId}/discounts/${id}`),
    effectiveDiscounts: clientId => api.getJson(`clients/${clientId}/effective_discounts`),
    // body: {promotion_id} or {coupon_id} (a bare coupon, no region/eligibility gate)
    applyDiscount: (clientId, body) => api.postJson(`clients/${clientId}/discounts`, body),
    cancelClientDiscount: (clientId, id, body) => api.postJson(`clients/${clientId}/discounts/${id}/cancel`, body),
    validateCode: (clientId, body) => api.postJson(`clients/${clientId}/promotion_code_validations`, body),
    redeemCode: (clientId, body) => api.postJson(`clients/${clientId}/promotion_code_redemptions`, body),
    previewClient: (clientId, body) => api.postJson(`clients/${clientId}/discount_preview`, body),

    simulate: body => api.postJson('billing/simulations', body),
    listSimulations: () => api.getJson('billing/simulations'),
    cmrReport: params => api.getJson('discount_reports/cmr', params),
    getSimulation: id => api.getJson(`billing/simulations/${id}`),

    // Existing envelope endpoint, used for the simulate screen's client picker
    searchClients: searchText => api.post('clients/search', { searchText, perPage: 10 }).then(r => r.value.clients || [])
};



// WEBPACK FOOTER //
// ./app/components/discounts/discountApi.js